export const campaign_params = ['utm_source', 'utm_medium', 'utm_content'];
export const campaign_params_no_utm = ['source', 'medium', 'content'];